// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { generateBarcodeLabel } from "./schema/generate-barcode-label";
import { generateInventoryLevelReport } from "./schema/generate-inventory-level-report";
import { getAvailableChannels } from "./schema/get-available-channels";
import { getCatalogTags } from "./schema/get-catalog-tags";
import { getCatalogUniqueValues } from "./schema/get-catalog-unique-values";
import { getCatalogVendors } from "./schema/get-catalog-vendors";
import { getConsignmentCatalog } from "./schema/get-consignment-catalog";
import { getInventoryMerchants } from "./schema/get-inventory-merchants";
import { getInventoryProducts } from "./schema/get-inventory-products";
import { getInventoryProductsCount } from "./schema/get-inventory-products-count";
import { getLocations } from "./schema/get-locations";
import { getProductCatalogCount } from "./schema/get-product-catalog-count";
import { getProductInventory } from "./schema/get-product-inventory";
import { getProductsForInventory } from "./schema/get-products-for-inventory";
import { getShopifyPublications } from "./schema/get-shopify-publications";
import { getSkuOnHandHistory } from "./schema/get-sku-on-hand-history";
import { getSkuSalesForecast } from "./schema/get-sku-sales-forecast";
import { getSkuSalesForecastBatch } from "./schema/get-sku-sales-forecast-batch";
import { getSuggestedProductsForLiquidation } from "./schema/get-suggested-products-for-liquidation";
import { getVariantInventoryByLocation } from "./schema/get-variant-inventory-by-location";
import { getWarehouses } from "./schema/get-warehouses";
import { getWarehousesForTeam } from "./schema/get-warehouses-for-team";
import { listConsignedProducts } from "./schema/list-consigned-products";
import { generateProductBarcode } from "./schema/product-catalog/generate-product-barcode";
import { searchProducts } from "./schema/search-products";
import { searchProductsByBarcode } from "./schema/search-products-by-barcode";
import { setProductLocations } from "./schema/set-product-locations";
import { upsertInventoryItem } from "./schema/upsert-inventory-item";
import { updateInventoryViewOrdering } from "./schema/views/update-inventory-view-ordering";

export const groupF = {
  updateInventoryViewOrdering,
  setProductLocations,
  generateBarcodeLabel,
  generateProductBarcode,
  generateInventoryLevelReport,
  getAvailableChannels,
  getCatalogTags,
  getCatalogUniqueValues,
  getCatalogVendors,
  getConsignmentCatalog,
  getInventoryMerchants,
  getInventoryProducts,
  getInventoryProductsCount,
  getLocations,
  getProductCatalogCount,
  getProductInventory,
  getProductsForInventory,
  getShopifyPublications,
  getSkuOnHandHistory,
  getSkuSalesForecast,
  getSkuSalesForecastBatch,
  getSuggestedProductsForLiquidation,
  getVariantInventoryByLocation,
  getWarehouses,
  getWarehousesForTeam,
  listConsignedProducts,
  searchProducts,
  searchProductsByBarcode,
  upsertInventoryItem,
};
